import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ImportEventsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type ImportEventsSubscription = { __typename?: 'Subscription', importEvents: { __typename?: 'DownloadJobProgressPayload', id: string, jobId: string, state: Types.PremiereTransferState, bytesSent: number, bytesTotal: number, percentage: number, failedItems: number, completedItems: number, totalItems: number } | { __typename?: 'ImportCanceledPayload', id: string } | { __typename?: 'ImportCompletePayload', paths: Array<string>, id: string, errors: Array<{ __typename?: 'ImportItemError', path: string, message: string }> } };


export const ImportEvents = /*#__PURE__*/ gql`
    subscription ImportEvents {
  importEvents {
    ... on DownloadJobProgressPayload {
      id
      jobId
      state
      bytesSent
      bytesTotal
      percentage
      failedItems
      completedItems
      totalItems
    }
    ... on ImportCompletePayload {
      paths
      errors {
        path
        message
      }
      id
    }
    ... on ImportCanceledPayload {
      id
    }
  }
}
    ` as unknown as DocumentNode<ImportEventsSubscription, ImportEventsSubscriptionVariables>;

          

          export const useImportEventsSubscription = (options?:SubscriptionHookOptions<ImportEventsSubscription, ImportEventsSubscriptionVariables>) => useSubscription(ImportEvents, options);

          

          export type ImportEventsSubscriptionOptions = SubscriptionHookOptions<ImportEventsSubscription, ImportEventsSubscriptionVariables>;

          

          export type ImportEventsSubscriptionResult = ReturnType<typeof useImportEventsSubscription>;

          
